const readMoreProduct = document.querySelector('.js-product__read-more');
const readLessProduct = document.querySelector('.js-product__read-less');
const productDescription = document.querySelector('.js-product__description');

if (readMoreProduct && readLessProduct && productDescription) {
  productDescription.classList.remove('product__description--show');
  readLessProduct.classList.add('product__read-less--hide');
  readMoreProduct.hidden = true;

  requestAnimationFrame(() => {
    const truncated = productDescription.scrollHeight > productDescription.clientHeight + 1;
    if (truncated) {
      readMoreProduct.classList.remove('product__read-more--hide');
      readMoreProduct.hidden = false;
    } else {
      productDescription.classList.add('product__description--show');
      readMoreProduct.classList.add('product__read-more--hide');
      readMoreProduct.hidden = true;
    }
  });

  readMoreProduct.addEventListener('click', () => {
    productDescription.classList.add('product__description--show');
    readMoreProduct.classList.add('product__read-more--hide');
    readMoreProduct.hidden = true;
    readLessProduct.classList.remove('product__read-less--hide');
  });

  readLessProduct.addEventListener('click', () => {
    productDescription.classList.remove('product__description--show');
    readLessProduct.classList.add('product__read-less--hide');
    readMoreProduct.classList.remove('product__read-more--hide');
    readMoreProduct.hidden = false;
  });
}

const mainProductSection = document.querySelector('section[id^="MainProduct-"]');
const mainButtonsRow =
  mainProductSection instanceof HTMLElement
    ? mainProductSection.querySelector('.main-product__row-buttons')
    : null;
const stickyButtonsRow =
  mainProductSection instanceof HTMLElement
    ? mainProductSection.querySelector('.main-product__row-buttons--sticky')
    : null;

if (
  document.body.classList.contains('page-template-product') &&
  mainButtonsRow instanceof HTMLElement &&
  stickyButtonsRow instanceof HTMLElement
) {
  const mainQuantityInput = mainButtonsRow.querySelector('.quantity__input');
  const stickyQuantityInput = stickyButtonsRow.querySelector('.quantity__input');

  const syncQuantity = function () {
    if (!mainQuantityInput || !stickyQuantityInput) return;
    mainQuantityInput.value = stickyQuantityInput.value;
    mainQuantityInput.dispatchEvent(new Event('change', { bubbles: true }));
  };

  if (mainQuantityInput && stickyQuantityInput) {
    stickyQuantityInput.removeAttribute('form');
    stickyQuantityInput.removeAttribute('name');
    stickyQuantityInput.value = mainQuantityInput.value;

    stickyQuantityInput.addEventListener('change', syncQuantity);
  }

  stickyButtonsRow.classList.remove('is-visible');
  document.body.appendChild(stickyButtonsRow);

  const target = mainButtonsRow;

  let headerMarginTop = 0;
  const headerHeightVar = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
  const headerHeight = parseFloat(headerHeightVar);

  if (!Number.isNaN(headerHeight) && headerHeight > 0) {
    headerMarginTop = -headerHeight;
  }

  const updateBodyOffset = function () {
    const isVisible = stickyButtonsRow.classList.contains('is-visible');
    document.body.style.paddingBottom = isVisible ? `${stickyButtonsRow.offsetHeight}px` : '';
  };

  const observer = new IntersectionObserver(
    (entries) => {
      const entry = entries[0];
      stickyButtonsRow.classList.toggle('is-visible', !entry.isIntersecting);
      updateBodyOffset();
    },
    {
      root: null,
      rootMargin: `${headerMarginTop}px 0px 0px 0px`,
    }
  );

  observer.observe(target);

  if ('ResizeObserver' in window) {
    new ResizeObserver(updateBodyOffset).observe(stickyButtonsRow);
  }
}

const initPaypalMessageSync = function () {
  const productSectionElement = document.querySelector('section[id^="MainProduct-"]');
  if (!(productSectionElement instanceof HTMLElement)) return;

  const priceRootElement = productSectionElement.querySelector('[id^="price-"]');
  const sectionId = productSectionElement.dataset.section;
  if (!(priceRootElement instanceof HTMLElement) || !sectionId) return;

  let observedPriceContainer = priceRootElement.querySelector('.price__container');
  if (!(observedPriceContainer instanceof HTMLElement)) return;

  const mutationConfig = { childList: true, subtree: true, characterData: true };
  let refreshTimer = null;
  let inFlightController = null;
  let lastPriceSnapshot = '';
  let giftWrapper = null;

  const getGiftTierAmount = function () {
    const costLabel = giftWrapper
      ?.querySelector('input[name="dicountTierBtn"]:checked')
      ?.closest('.gfgGridBox')
      ?.querySelector('.gfgCostLabel');
    const amount = Number.parseFloat(costLabel?.textContent?.replace(/,/g, '').match(/(\d+\.\d{2}|\d+)/)?.[0] ?? '');
    return Number.isFinite(amount) ? amount : null;
  };

  const renderPaypal = function () {
    const paypalMessageElement = productSectionElement.querySelector('.product__paypal [data-pp-message]');
    if (!(paypalMessageElement instanceof HTMLElement) || typeof window.paypal?.Messages !== 'function') return;

    const giftAmount = getGiftTierAmount();
    if (giftAmount !== null) {
      paypalMessageElement.setAttribute('data-pp-amount', giftAmount.toFixed(2));
    }

    window.paypal.Messages().render(paypalMessageElement);
  };

  const replacePaypalBlockFromServer = async function () {
    const variantInput = productSectionElement.querySelector('form[action*="/cart/add"] input[name="id"]');
    const requestUrl = new URL(window.location.href);

    requestUrl.searchParams.set('section_id', sectionId);
    if (variantInput instanceof HTMLInputElement && variantInput.value) {
      requestUrl.searchParams.set('variant', variantInput.value);
    }

    inFlightController?.abort();
    inFlightController = new AbortController();

    try {
      const response = await fetch(requestUrl.toString(), {
        signal: inFlightController.signal,
        credentials: 'same-origin',
      });
      if (!response.ok) return;

      const nextPaypalBlock = new DOMParser()
        .parseFromString(await response.text(), 'text/html')
        .querySelector('.product__paypal');
      const currentPaypalBlock = productSectionElement.querySelector('.product__paypal');

      if (!(nextPaypalBlock instanceof HTMLElement) || !(currentPaypalBlock instanceof HTMLElement)) return;

      currentPaypalBlock.innerHTML = nextPaypalBlock.innerHTML;
      renderPaypal();
    } catch (error) {
      if (error?.name === 'AbortError') return;
    }
  };

  const scheduleRefresh = function (fromServer) {
    if (refreshTimer) window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(function () {
      const giftAmount = getGiftTierAmount();
      if (fromServer || giftAmount === null) replacePaypalBlockFromServer();
      else renderPaypal();
    }, 120);
  };

  const priceObserver = new MutationObserver(function () {
    const snapshot = observedPriceContainer.textContent?.trim() ?? '';
    if (!snapshot || snapshot === lastPriceSnapshot) return;
    lastPriceSnapshot = snapshot;
    scheduleRefresh(true);
  });

  const bindPriceContainer = function () {
    const nextPriceContainer = priceRootElement.querySelector('.price__container');
    if (!(nextPriceContainer instanceof HTMLElement) || nextPriceContainer === observedPriceContainer) return;
    observedPriceContainer = nextPriceContainer;
    priceObserver.disconnect();
    priceObserver.observe(observedPriceContainer, mutationConfig);
    scheduleRefresh(true);
  };

  const giftObserver = new MutationObserver(function () {
    scheduleRefresh(false);
  });

  const bindGiftWrapper = function () {
    const nextGiftWrapper = productSectionElement.querySelector('.gfgVolDiscountWrapper');
    if (!(nextGiftWrapper instanceof HTMLElement) || nextGiftWrapper === giftWrapper) return;
    giftWrapper = nextGiftWrapper;
    giftObserver.disconnect();
    giftObserver.observe(giftWrapper, mutationConfig);
  };

  const onGiftTierInteraction = function (event) {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const isGiftTier =
      target.closest('.gfgVolDiscountWrapper .gfgGridBox') ||
      (target instanceof HTMLInputElement && target.name === 'dicountTierBtn');
    if (isGiftTier) scheduleRefresh(false);
  };

  productSectionElement.addEventListener('click', onGiftTierInteraction);
  productSectionElement.addEventListener('change', onGiftTierInteraction);

  priceObserver.observe(observedPriceContainer, mutationConfig);
  new MutationObserver(bindPriceContainer).observe(priceRootElement, { childList: true, subtree: true });

  bindGiftWrapper();
  new MutationObserver(bindGiftWrapper).observe(productSectionElement, { childList: true, subtree: true });
};

initPaypalMessageSync();
